import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  num: '01',
  title: 'Kit Express de Primera Reunión',
  desc: 'Guión + hoja de diagnóstico + checklist de cierre',
  value: '$15.000'
}, {
  num: '02',
  title: 'Pack de Mensajes para WhatsApp y Airbnb',
  desc: '84+ mensajes listos para copiar y pegar',
  value: '$12.000'
}, {
  num: '03',
  title: 'Combo de Checklists Operativos',
  desc: '10 checklists listos para imprimir y usar',
  value: '$10.000'
}, {
  num: '04',
  title: 'Kit de Objeciones y Cierres',
  desc: '25 objeciones reales con respuestas listas',
  value: '$12.000'
}, {
  num: '05',
  title: 'Pack de Presentación Profesional',
  desc: 'One-pager + bio + proyección de ingresos editable',
  value: '$10.000'
}, {
  num: '06',
  title: 'Kit de Arranque en 7 Días',
  desc: 'Plan diario para cerrar tu primera propiedad esta semana',
  value: '$10.000'
}];
export function BonusSection() {
  return <section className="py-20 bg-surface" data-id="element-39">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-40">
        <div className="text-center mb-12" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-42">
            🎁 6 BONOS — SIEMPRE INCLUIDOS
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden mb-8" data-id="element-43">
          {/* Table Header */}
          <div className="hidden md:grid grid-cols-[60px_1fr_120px] bg-gray-50 border-b border-gray-200 px-6 py-3" data-id="element-44">
            <span className="text-xs font-bold text-gray-500 uppercase" data-id="element-45">#</span>
            <span className="text-xs font-bold text-gray-500 uppercase" data-id="element-46">
              Bono
            </span>
            <span className="text-xs font-bold text-gray-500 uppercase text-right" data-id="element-47">
              Valor
            </span>
          </div>

          {/* Table Rows */}
          {bonuses.map((bonus, i) => <div key={i} className={`grid md:grid-cols-[60px_1fr_120px] gap-2 md:gap-0 px-6 py-4 items-center ${i < bonuses.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-48">
              <span className="text-primary font-bold text-sm" data-id="element-49">
                {bonus.num}
              </span>
              <div data-id="element-50">
                <span className="font-bold text-gray-900 text-sm" data-id="element-51">
                  {bonus.title}
                </span>
                <span className="text-gray-500 text-sm" data-id="element-52"> — {bonus.desc}</span>
              </div>
              <div className="text-right" data-id="element-53">
                <span className="text-gray-400 line-through text-sm mr-2" data-id="element-54">
                  {bonus.value}
                </span>
                <span className="text-green-600 font-bold text-sm" data-id="element-55">GRATIS</span>
              </div>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-5 md:p-6 text-white text-center shadow-xl shadow-primary/20" data-id="element-56">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-lg md:text-xl font-bold" data-id="element-57">
            <span data-id="element-58">Valor total bonos</span>
            <span className="line-through opacity-60" data-id="element-59">$69.000 ARS</span>
            <span className="text-green-300 bg-white/10 px-4 py-1 rounded-full" data-id="element-60">
              → GRATIS con tu Megapack
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}